// Public Eventbrite event ids are 1003x the private id used internally.
// The PicoX tracking plan asks for the private id,
// so every call site must convert before adding eb_event_id /
// parent_eb_event_id to a payload. Mirrors the helper in
// eb-ui (`packages/attendee/checkout/src/utils/picoTracking/ids.ts`)
// so the funnel reports consistent ids across listing and checkout.
const PUBLIC_TO_PRIVATE_DIVISOR = 1003;

export const toPrivateEventIdNumber = (publicId: string | number | null | undefined): number | null => {
  if (publicId == null || publicId === '') {
    return null;
  }
  const privateId = Number(publicId) / PUBLIC_TO_PRIVATE_DIVISOR;
  if (!Number.isFinite(privateId) || privateId === 0) {
    return null;
  }
  return privateId;
};

export const toPrivateEventId = (publicId: string | number | null | undefined): string | null => {
  const privateId = toPrivateEventIdNumber(publicId);
  return privateId === null ? null : String(privateId);
};
